import { createContext, useContext } from 'react'
import { companyMessage } from '../../assets/i18n/i18n'

 const PortalTitleContext = createContext(
  `${companyMessage.PreferedName} ${companyMessage.DataPortalTitle}`
)

export const usePortalTitle = () => useContext(PortalTitleContext)